import CountryProvider from './CountryDetailsContext';
import CountryDetails from './CountryDetails';
import { Page } from 'components';

let Index = () => {
    return (
        <CountryProvider>
            <Page title="Country" maxWidth='md'>
                <CountryDetails />
            </Page>
        </CountryProvider>
    )
}

export default Index;